export function getImportanceColor(importance: string): string {
  switch (importance) {
    case "critical":
      return "text-red-500";
    case "high":
      return "text-orange-500";
    case "low":
      return "text-zinc-400";
    default:
      return "text-zinc-500";
  }
}

export function getSeverityBarColor(severity: string): string {
  switch (severity) {
    case "high":
      return "bg-red-500";
    case "medium":
      return "bg-yellow-400";
    default:
      return "bg-green-400";
  }
}

export function getSelectedCardClass(isSelected: boolean): string {
  return isSelected
    ? "border-blue-300 shadow-md ring-1 ring-blue-200 bg-white"
    : "border-gray-200 bg-white hover:border-blue-300 hover:shadow-md";
}
